/**
 * Platform kill-switch for the agent draft assistant (header AI button).
 * Flag comes from window.globalConfig (DashboardController app_config merge of
 * AiAgent::PlatformConfig AI_AGENT_ASSIST_ENABLED). Default off.
 */

const KEY = 'AI_AGENT_ASSIST_ENABLED';

const readFlag = (raw, defaultValue) => {
  if (raw === undefined || raw === null || raw === '') return defaultValue;
  if (typeof raw === 'boolean') return raw;
  if (typeof raw === 'string') {
    const normalized = raw.trim().toLowerCase();
    if (['true', '1', 'yes'].includes(normalized)) return true;
    if (['false', '0', 'no'].includes(normalized)) return false;
  }
  return Boolean(raw);
};

export const isAiAssistEnabled = () => {
  try {
    return readFlag(window.globalConfig?.[KEY], false);
  } catch (_error) {
    return false;
  }
};
